module.exports = __webpack_public_path__ + "img/boulevardier.07152d4c.jpg";